/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom'
import Spinner from '../components/Spinner'
import { POST } from '../../../helpers/httphelper';
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable';
function DoctorView(props) {
    const params = useParams()
    const tid = params.tid
    const oid = params.oid

    const [token, settoken] = useState()
    const [user, setuser] = useState()
    const [channelings, setchannelings] = useState([])
    const [medicines, setmedicines] = useState([])
    const [labs, setlabs] = useState([])
    const [loading, setloading] = useState(false)
    const [mloading, setmloading] = useState(false)
    const [feedback, setfeedback] = useState('')


    useEffect(() => {
        getdata()

    }, [])

    const getdata = () => {
        POST(`api/token/gettoken`, { tid, oid }).then(data => {
            settoken(data.token)
            setuser(data.user)
            getChannelings()


        }).catch(err => {
            console.log(err)
        })

    }

    const getChannelings = () => {
        setloading(true)
        POST(`api/token/getchannelings`, { tid }).then(data => {
            setchannelings(data)
            setloading(false)
        }).catch(err => {
            console.log(err)
        })
    }

    const showmodal1 = (reason) => {
        setmloading(true)
        POST(`api/token/getmedi`, { reason }).then(data => {
            setmedicines(data)
            setmloading(false)
        }).catch(err => {
            console.log(err)
        })

        document.getElementById("modal1").classList.add("is-active")
    }

    const hidemodal1 = () => {
        document.getElementById("modal1").classList.remove("is-active")
    }

    const showmodal2 = (id) => {
        for (var i = 0; i < channelings.length; i++) {
            if (id === channelings[i]._id) {
                setlabs(channelings[i].labtests)
                break
            }
        }
        document.getElementById("modal2").classList.add("is-active")
    }

    const hidemodal2 = () => {
        document.getElementById("modal2").classList.remove("is-active")
    }

    const showFeedbackModal = (feedback) => {

        document.getElementById("modal4").classList.add("is-active")
        setfeedback(feedback)
    }

    const hideFeedbackModal = () => {

        document.getElementById("modal4").classList.remove("is-active")
    }
    const generateReport = () => {
        // const doc = new jsPDF()
        // autoTable(doc, { html: '#table1' })
        // doc.save('table.pdf')

        const doc = new jsPDF()
        let data = []

        channelings.forEach((element, index, array) => {
            data.push([(index + 1), element.reason, moment(element.date).format("YYYY-MM-DD"), element.doctorName, element.visitCity, element.time, element.feedback])
        })
        doc.text(90, 10, "Patient's Bio");
        autoTable(doc, {
            head: [['', '']],
            body: [["Name", user.fname], ["Date of Birth", moment(user?.birth).format("YYYY-MM-DD")], ["Email", user.email], ["Gender", user.gender], ["Mobile", user.mobile]],
            margin: { bottom: 60 }
        })
        doc.text(80, 80, "Patient's Channelings");
        autoTable(doc, {
            head: [['No', 'Reason', 'Date', 'Doctor Name', 'Visited city', 'Time', 'Feedback']],
            body: data,
            startY: doc.lastAutoTable.finalY + 25

        })


        doc.save('channelings.pdf')
    }
    return (
        <div className='container'>
            <div className='columns is-mobile  is-justify-content-center is-multiline is-gapless'>
                <div className='column is-3-widescreen is-6-desktop is-6-tablet is-10-mobile box  bio_column mr-5' id="s">
                    <div className='columns is-justify-content-center is-multiline is-mobile'>
                        <div className='column is-12'>
                            <h1 className='has-text-centered mt-6 title is-4'>Patient's Information</h1>
                        </div>
                        <div className='colum is-12'>
                            <div className='columns'> <div className='column is-4'>
                                <figure className="image pic_user">
                                    <img alt='' className="is-rounded" src={user?.image} />
                                </figure>
                            </div></div>
                        </div>
                        <div className='column is-12'>
                            <div className='columns is-justify-content-center is-mobile'>
                                <div className='column is-12-widescreen is-6-desktop is-10-tablet is-10-mobile'>
                                    <div className='columns is-justify-content-center ml-5 mb-0 is-mobile'>
                                        <div className='column is-2 mx-5'>
                                            Name
                                        </div>
                                        <div className='column is-9'>
                                            {user?.fname}
                                        </div>
                                    </div>

                                    <div className='columns columns is-justify-content-center ml-5 mb-0 is-mobile'>
                                        <div className='column is-2 '>
                                            Email
                                        </div>
                                        <div className='column is-9' style={{ fontSize: "14px" }}>
                                            {user?.email}
                                        </div>
                                    </div>

                                    <div className='columns columns is-justify-content-center ml-5 mb-0 is-mobile'>
                                        <div className='column is-2 mx-5'>
                                            DOB
                                        </div>
                                        <div className='column is-9'>
                                            {moment(user?.birth).format("YYYY-MM-DD")}
                                        </div>
                                    </div>

                                    <div className='columns columns is-justify-content-center ml-5 mb-0 is-mobile'>
                                        <div className='column is-2 mx-5'>
                                            Gender
                                        </div>
                                        <div className='column is-9'>
                                            <span className='tag is-primary'> {user?.gender}</span>
                                        </div>
                                    </div>

                                    <div className='columns columns is-justify-content-center ml-5 mb-0 is-mobile'>
                                        <div className='column is-2 mx-5'>
                                            Phone
                                        </div>
                                        <div className='column is-9'>
                                            <span className='tag is-info'>  {user?.mobile}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='column is-8-widescreen is-10-desktop is-10-tablet is-11-mobile mt-6'>

                    <div className='columns is-mobile is-justify-content-center is-multiline'>
                        <div className='column is-12 box'>
                            <div className='columns is-mobile is-multiline'>
                                <div className='column is-full'>
                                    <button class="button is-link is-rounded" onClick={(e) => { generateReport() }}>
                                        <span class="icon">
                                            <i class="far fa-file-pdf"></i>
                                        </span>
                                        <span>Report</span>
                                    </button>
                                    <h1 className='has-text-centered title is-4'>Channelings</h1>
                                </div>
                            </div>

                            <div className='columns is-multiline is-mobile'>
                                <div className='column is-full'>
                                    {loading ? <>
                                        <div className='columns is-justify-content-center'>
                                            <div className='column is-2'>
                                                <Spinner />
                                            </div>
                                        </div>
                                    </> : <>
                                        <div className='columns is-mobile is-multiline'>
                                            <div className='column is-12-desktop is-12-tablet is-12-mobile'>
                                                <table className='table is-hoverable is-striped is-fullwidth' id="table1">
                                                    <thead>
                                                        <tr>
                                                            <th>No</th>
                                                            <th>Reason</th>
                                                            <th>Date</th>
                                                            <th>Doctor Name</th>
                                                            <th>Prescription</th>
                                                            {token?.medicine ? <><th>Medicine</th></> : <></>}
                                                            {token?.lab ? <><th>Lab Test</th></> : <></>}
                                                            <th>Feedback</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {channelings?.map((m, i) => (
                                                            <tr key={i}>
                                                                <td>{(i + 1)}</td>
                                                                <td>{m?.reason}</td>
                                                                <td>{moment(m?.date).format("YYYY-MM-DD")}</td>
                                                                <td>{m?.doctorName}</td>
                                                                <td><a href={m?.pimage} className='button is-primary' target="blank"><i class="fas fa-eye"></i></a></td>
                                                                {token?.medicine ? <><td><a href className='button is-info' onClick={(e) => { showmodal1(m.reason) }}><i class="fas fa-eye"></i></a></td></> : <></>}

                                                                {token?.lab ? <><td><a href className='button is-success' onClick={(e) => { showmodal2(m._id) }}><i class="fas fa-eye"></i></a></td></> : <></>}
                                                                <td><a href className='button is-warning' target="blank" onClick={(e) => { showFeedbackModal(m.feedback) }}><i class="fas fa-eye"></i></a></td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </>}




                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div className="modal" id="modal1">
                <div className="modal-background"></div>
                <div className="modal-card">
                    <header className="modal-card-head has-background-info">
                        <p className="modal-card-title has-text-centered" style={{ color: "white" }}>Medicines</p>
                        <button className="delete" aria-label="close" onClick={(e) => { hidemodal1() }}></button>
                    </header>
                    <section className="modal-card-body">
                        <div className='columns is-mobile'>
                            <div className='column is-12'>
                                {mloading ? <>
                                    <div className='columns is-justify-content-center'>
                                        <div className='column is-2'>
                                            <Spinner />
                                        </div>
                                    </div>

                                </> : <>
                                    {medicines?.length === 0 ? <>
                                        <h1 className='subtitle has-text-centered'>No Medicines Available</h1>
                                    </> : <>

                                        <table className='table is-hoverable is-fullwidth is-striped'>
                                            <thead>
                                                <tr>
                                                    <th>No</th>
                                                    <th>Name</th>
                                                    <th>S.Date</th>
                                                    <th>E.Date</th>
                                                    <th>Dosage</th>
                                                    <th>Frequency</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {medicines?.map((m, i) => (
                                                    <tr key={i}>
                                                        <td>{(i + 1)}</td>
                                                        <td>{m?.MedicineName}</td>
                                                        <td>{m?.StartDate}</td>
                                                        <td>{m?.EndDate}</td>
                                                        <td>{m?.Dosage}</td>
                                                        <td>{m?.Frequency}</td>

                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </>}
                                </>}


                            </div>
                        </div>
                    </section>

                </div>
            </div>


            <div className="modal" id="modal2">
                <div className="modal-background"></div>
                <div className="modal-card">
                    <header className="modal-card-head has-background-success">
                        <p className="modal-card-title has-text-centered" style={{ color: "white" }}>Lab Tests</p>
                        <button className="delete" aria-label="close" onClick={(e) => { hidemodal2() }}></button>
                    </header>
                    <section className="modal-card-body">
                        <div className='columns is-mobile'>
                            <div className='column is-full'>
                                {loading ? <>
                                    <div className='columns is-justify-content-center'>
                                        <div className='column is-2'>
                                            <Spinner />
                                        </div>
                                    </div>
                                </> : <>
                                    {labs?.length === 0 ? <>
                                        <h1 className='subtitle has-text-centered'>No Lab Tests Available</h1>
                                    </> : <>
                                        <table className='table  is-hoverable is-fullwidth is-striped'>
                                            <thead>
                                                <tr>
                                                    <th>No</th>
                                                    <th>Name</th>
                                                    <th>Date</th>
                                                    <th>Report</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {labs?.map((m, i) => (
                                                    <tr key={i}>
                                                        <td>{(i + 1)}</td>
                                                        <td>{m?.name}</td>
                                                        <td>{moment(m?.date).format("YYYY-MM-DD")}</td>
                                                        <td><a href={m?.report} className='button is-primary' target="blank"><i class="fas fa-eye"></i></a></td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>

                                    </>}

                                </>}

                            </div>
                        </div>

                    </section>

                </div>
            </div>



            <div className="modal" id="modal4">
                <div className="modal-background"></div>
                <div className="modal-card">
                    <header className="modal-card-head has-background-warning">
                        <p className="modal-card-title has-text-centered">Doctor Feedback</p>
                        <button className="delete" aria-label="close" onClick={(e) => { hideFeedbackModal() }}></button>
                    </header>
                    <section className="modal-card-body">
                        <div className='columns'>
                            <div className='column is-full'>
                                {feedback === '' ? <>
                                    <h2 className='subtitile has-text-centered'>No FeedBack Added</h2>
                                </> : <>
                                    <h2 className='subtitile has-text-centered'>{feedback}</h2>
                                </>}
                            </div>
                        </div>
                    </section>

                </div>
            </div>
        </div>
    );
}

export default DoctorView;